import { AuthProviderProps } from "react-oidc-context";

import { WebStorageStateStore } from "oidc-client-ts";

import { AppConfig } from "../config/appConfig";
import { sanitizedCurrentUrl } from "./sanitizedCurrentUrl";

export function createOidcConfig(config: AppConfig): AuthProviderProps {
  return {
    authority: `${config.keycloakUrl}/realms/${config.keycloakRealm}`,
    client_id: config.keycloakClientId,
    redirect_uri: `${config.appUrl}/callback`,
    post_logout_redirect_uri: config.appUrl,
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    onSigninCallback: () => {
      // AuthGuard sends the user to Keycloak with redirect_uri set to their current deep link, so the
      // browser already lands back on the right page — we only need to strip the OIDC query params.
      window.history.replaceState({}, document.title, sanitizedCurrentUrl());
    },
  };
}
